'use strict';

var cardSlideshow = require('./card-slideshow');

var init = function() {
	cardSlideshow.init();

};

module.exports = {
	init: init
};
